import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.5 0.75C14.9493 0.75 17.6734 1.61288 19.5303 3.46973C21.3871 5.32657 22.25 8.05065 22.25 11.5C22.25 14.9493 21.3871 17.6734 19.5303 19.5303C17.6734 21.3871 14.9493 22.25 11.5 22.25C8.05065 22.25 5.32657 21.3871 3.46973 19.5303C1.61288 17.6734 0.75 14.9493 0.75 11.5C0.75 8.05065 1.61288 5.32657 3.46973 3.46973C5.32657 1.61288 8.05065 0.75 11.5 0.75Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.38123 14.965C5.38123 10.9166 8.09134 6.53148 13.3144 5.68593C13.3144 5.68593 14.8785 5.40653 15.6331 5.7021C15.9163 5.79033 16.3003 6.1212 16.3714 6.52119C16.5449 7.21234 15.894 7.77702 15.8555 7.80937C15.8926 7.82261 16.45 8.02554 16.5582 8.52552C16.6561 8.97992 16.3418 9.34608 15.7829 9.53725C16.7109 10.3725 16.5152 12.043 15.645 12.8312C16.8785 12.9709 17.8347 13.768 17.8347 14.965C17.8347 15.8149 15.7591 16.1546 11.6065 16.1546C7.45384 16.1546 5.38123 15.8149 5.38123 14.965Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }